<!-- Imported Ats Integration Module from unified folder -->
 <router-outlet></router-outlet>